import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as FileSaver from 'file-saver';
import { environment } from 'public/environments/environment';

@Injectable({ providedIn: 'root' })
export class ConnectLookupsService {

  constructor(private http: HttpClient) {
  }

  getNationalities() {
    return this.http.get(`${environment.apiUrl}/Lookup/Nationalities`);
  }
  GetCountries() {
    return this.http.get(`${environment.apiUrl}/lookup/Countries`);
  }
  GetCities(countryId:any) {
    return this.http.get(`${environment.apiUrl}/lookup/Cities/${countryId}`);
  }
  getMenu() {
    return this.http.get(`${environment.apiUrl}/lookup/GetMenu`);
  }

  GetCurrentYear() {
    return this.http.get(`${environment.apiUrl}/lookup/GetCurrentYear`);
  }

  GetBillingType(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetBillingType`);
  }

  MedicalTreatmentPhases(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/MedicalTreatmentPhases`);
  }

  getEducationalDegrees(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetEducationalDegrees`);
  }
  getAllEmploymentTypes(): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetAllEmploymentTypes`);
  }
  getMonths(): any {
    return this.http.get(`${environment.apiUrl}/BookADemo/GetMonths`);
  }

  downloadAttachment(file:any) {
    return this.http.get(
      `${environment.apiUrl}/Lookup/DownloadAttachment/${file.attachmentId}?Url=${file.path}`
    ).pipe().subscribe((response: any) => {
      const blob = this.dataURItoBlob(response.file); // base 64 to blob
      const blobFile: Blob = new Blob([blob], { type: response.contentType });
      FileSaver.saveAs(blobFile, response.name);
    });
  }
  dataURItoBlob(dataURI:any) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/png' });
    return blob;
  }
}
